import { validateError, validateRequest, validateSuccess } from "../features/slices/lockScreenSlice";
import { appInit as appInitReducer, userLogin } from "../features/slices/rootSlice";
import { logoutUrl } from "../utils/constants";
import Api from "../api";
export const appInit = (url, isLogged, title) => (dispatch, getState) => {
    dispatch(appInitReducer({ url, isLogged: isLogged ?? false, title }));
};
export const logout = () => (dispatch, getState) => {
    if (getState().root.isLogged) {
        const frameSessions = Object.values(getState().root.tabs).map(x => ['fs', x.frameSession ?? ""]);
        const queryString = new URLSearchParams(frameSessions).toString();
        dispatch(appInit(logoutUrl + "&" + queryString, false, "Logout"));
    }
};
export const resetUserLogin = () => async (dispatch, getState) => {
    await Api.resetUserLogin().then((resetUserLoginResult) => {
        dispatch(userLogin(resetUserLoginResult.data));
    });
};
export const unlockScreen = (password) => (dispatch, getState) => {
    dispatch(validateRequest());
    Api.validate(password)
        .then(() => dispatch(validateSuccess()))
        .catch(() => dispatch(validateError("Login was unsuccessful!")));
};
